export default __webpack_public_path__ + "static/media/instagram.d662ee4f.svg";